import snakeCase from 'lodash/snakeCase'

import { API_DATE_REGEXP } from './constants'
import { isObject } from './isObject'

export const snakeCasifyProperties = (entity: unknown): any => {
  if (Array.isArray(entity)) {
    return entity.map(snakeCasifyProperties)
  }

  if (isObject(entity)) {
    return Object.keys(entity).reduce(
      (acc, key) => ({
        ...acc,
        [API_DATE_REGEXP.test(key) ? key : snakeCase(key)]: snakeCasifyProperties(entity[key]),
      }),
      {}
    )
  }

  return entity
}
